class DateCounter extends HTMLElement {
  constructor() {
    super();

    this.countdownDateAttr = null;
    this.countdownDate = null;
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
    this.countdownTimer = null;
    this.timerEnded = null;
  }

  connectedCallback() {
    this.countdownDateAttr = this.getAttribute('data-end-date');
    this.countdownDate = this.parseDate(this.countdownDateAttr);
    if (isNaN(this.countdownDate)) {
      console.error('Invalid date format:', this.countdownDateAttr);
      return;
    }
    this.days = this.querySelector('[data-ref="days"]');
    this.hours = this.querySelector('[data-ref="hours"]');
    this.minutes = this.querySelector('[data-ref="minutes"]');
    this.seconds = this.querySelector('[data-ref="seconds"]');
    this.countdownTimer = this.querySelector('[data-ref="countdown-timer"]');
    this.timerEnded = this.querySelector('[data-ref="timer-ended"]');

    this.showMinutes = this.isUnitShown(this.minutes);
    this.showSeconds = this.isUnitShown(this.seconds);

    this.onVisible = () => {
      if (!document.hidden) this.updateCountdown();
    };
    document.addEventListener('visibilitychange', this.onVisible);

    this.updateCountdown();
  }

  disconnectedCallback() {
    clearTimeout(this.interval);
    document.removeEventListener('visibilitychange', this.onVisible);
  }

  isUnitShown(el) {
    const card = el && el.closest('.countdown__timer-card');
    return !!card && !card.classList.contains('hidden');
  }

  // Wake up only when the smallest unit on screen changes: every second, every minute,
  // or (days and hours only) once an hour, right when the hour number changes.
  scheduleNext(distance) {
    clearTimeout(this.interval);
    let unit = 60 * 60 * 1000;
    if (this.showSeconds) unit = 1000;
    else if (this.showMinutes) unit = 60 * 1000;
    this.interval = setTimeout(() => this.updateCountdown(), (distance % unit) + 50);
  }

  parseDate(dateStr) {
    // Expected format: DD/MM/YYYY HH:mm
    const dateTimeParts = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})/);
    if (dateTimeParts) {
      const [_, day, month, year, hour, minute] = dateTimeParts.map(Number);
      return this.londonTime(year, month, day, hour, minute);
    }

    // Si le format n'est pas reconnu, retourne une date invalide
    return new Date('Invalid Date');
  }

  // The end date is London time for every visitor (not the visitor's own clock).
  londonTime(year, month, day, hour, minute) {
    const wallAsUtc = Date.UTC(year, month - 1, day, hour, minute);
    const offsetAt = (ts) => {
      const p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hourCycle: 'h23',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      })
        .formatToParts(new Date(ts))
        .forEach((part) => (p[part.type] = Number(part.value)));
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - ts;
    };
    let ts = wallAsUtc - offsetAt(wallAsUtc);
    ts = wallAsUtc - offsetAt(ts);
    return new Date(ts);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countdownDate.getTime() - now;

    if (distance < 0) {
      this.countdownTimer.classList.add('hidden');
      if (this.timerEnded.dataset.showMessage === 'true') {
        this.timerEnded.classList.remove('hidden');
      } else {
        this.closest('[data-ref="countdown"]').classList.add('hidden');
      }

      clearTimeout(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Affichage des jours, même s'ils sont à 0
    this.days.textContent = days;
    this.hours.textContent = hours.toString().padStart(2, '0');
    this.minutes.textContent = minutes.toString().padStart(2, '0');
    this.seconds.textContent = seconds.toString().padStart(2, '0');

    this.scheduleNext(distance);
  }
}

customElements.define('date-counter', DateCounter);
